<template>
  <div class="row">
    <div class="col-4">
      <card>
        <div slot="header">
          <l-button type="info" @click="handlenew()">新增</l-button>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <el-table :data="supportedLanguages">
              <!-- <el-table-column prop="id" label="ID">
              </el-table-column> -->
              <el-table-column :min-width="67" prop="displayName" label="語言" />
              <el-table-column :min-width="33" label="操作">
                <div class="td-actions" slot-scope="props">
                  <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs"
                    @click="handleEdit(props.row)"
                    v-show="props.row.id !== 1">
                    <i class="fa fa-edit" />
                  </a>
                  <!-- <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs"
                    @click="deleteUserGroup(props.row.id)"
                    v-show="props.row.id !== 1">
                    <i class="fa fa-close"></i>
                  </a> -->
                </div>
              </el-table-column>
            </el-table>
            
          </div>
        </div>
      </card>
    </div>
    

    <div class="col-12">
      <el-dialog
        center
        title="新增語言"
        :visible.sync="modals.custom">
        <fg-input label="語言名稱">
          <el-select
            class="select-default"
            data-vv-as="語言名稱"
            placeholder="請選擇"
            name="languageName"
            v-model="form.newLanguageCode"
            :error="getError('')"
            v-validate="modelValidations.name">
            <el-option v-for="i in availableLanguages" class="select-default" :value="i.LangCultureName" :label="i.DisplayName" :key="i.LangCultureName" />
          </el-select>
        </fg-input>
        <div class="text-right">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">確認</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        form: {
          // id: 0,
          // name: '',
          // permission:[]
          newLanguageCode: '',
          // newLanguageName: ''
        },

        modals: {
          basic: false,
          centered: false,
          custom: false,
          confirm: false
        },

        modelValidations: {
          name: {
            required: true,
          }
        },

        availableLanguages: [],
        supportedLanguages: []
      }
    },

    async mounted() {
      await this.getData()
    },

    methods: {
      // getTitle() {
      //   return (parseInt(this.form.id) == 0) ? '新增' : "編輯"
      // },

      getError(fieldName) {
        return this.errors.first(fieldName)
      },

      validate() {
        var _this = this
        this.errors.clear();
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;

          var displayName = ''
          for (var i = 0; i < this.availableLanguages.length; i++) {
            if (this.availableLanguages[i].LangCultureName == this.form.newLanguageCode) {
              displayName = this.availableLanguages[i].DisplayName
            }
          }
          
          _this.createSupportedLanguage(this.form.newLanguageCode, displayName);
        })
      },

      openModal(name) {
        this.modals[name] = true
      },
      closeModal (name) {
        this.modals[name] = false
      },

      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject){
          _this.form.id = 0
          _this.form.name = ''
          resolve()
        })
      },

      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },

      handleEdit (row) {
        // this.form.id = row.id
        // this.form.name = row.name
        // this.openModal('custom')
      },

      // handleDelete (index, row) {
      //   alert(`Your want to delete ${row.name}`)
      // },

      async getData() {
        var data = await lib.getAvailableLanguages()
        if (data.status == 0) {
          var result = data.result
          this.availableLanguages = result.languages
        }

        data = await lib.getSupportedLanguages()
        if (data.status == 0) {
          var result = data.result
          this.supportedLanguages = result.languages
        }
      },

      async createSupportedLanguage(code, displayName) {
        var data = await lib.createSupportedLanguage({language: {code: code, displayName: displayName}})
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 7) {
          this.closeModal('custom')
          this.$swal('該語言已存在', '', 'error')
        }
      }
    }
  }
</script>
<style>
</style>
